import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DataService } from 'src/app/core/services/data.service';
import { AuthService } from "src/app/core/services/auth.service";
import { AngularFireAuth } from '@angular/fire/compat/auth';

@Component({
  selector: 'app-email-login',
  templateUrl: './email-login.component.html',
  styleUrls: ['./email-login.component.css']
})
export class EmailLoginComponent {
  email: any;
  isEmailSent: boolean = false;
  errorMessage: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<EmailLoginComponent>, public dataService: DataService,
    private authService: AuthService, public fbAuth: AngularFireAuth) {

  }


  sendSignInLink() {
    // console.log(window.location.href); //__CONSOLE_LOG__

    window.localStorage.setItem('emailForSignIn', this.email);
    let deepLink = window.location.href;
    deepLink = deepLink.replace("login", "handle-signin");
    // console.log(deepLink); //__CONSOLE_LOG__

    const emailBody = `Click the following link to verify your email: ${deepLink}`;
    // console.log(emailBody); //__CONSOLE_LOG__
   // this.authService.sendSignInLink(this.email, deepLink);
    //this.email = '';
    //this.isEmailSent = true;
 
  this.authService.sendEmail(this.email,deepLink).subscribe({
    next: (res: any) => {
      this.email = '';
      this.isEmailSent = true;
    },
    error: (err) => {
      // console.error(err); //__CONSOLE_LOG__
    },
  })
}

 
  closeEmailDialog() {
    this.dialogRef.close();
  }



}
